module.exports = __webpack_public_path__ + "8eaef49680167feeef68fdc46430ac6a.gif";